/**
 * Two-tap confirm for destructive desk actions (Inquiries Desk → Dismiss).
 *
 * The second tap must be a decision, not the back half of a double tap.
 * TS2MFP (2026-10-05): on a phone the Dismiss button showed only an icon where
 * "close" usually sits, and two taps 474 ms apart erased a paid trip's
 * Confirmation Number Release work order. Muse confirms after 3–6 s; people
 * double-tap in well under one.
 */
export const DISMISS_CONFIRM_MIN_MS = 700;

/** How long the Undo bar stays up after a dismiss. */
export const UNDO_WINDOW_MS = 10000;

/** True when the confirming tap came long enough after the arming tap. */
export function isDeliberateConfirm(armedAtMs, nowMs) {
  return Number.isFinite(armedAtMs) && armedAtMs > 0 && nowMs - armedAtMs >= DISMISS_CONFIRM_MIN_MS;
}
